import { Order, OrderStatus, OrderType } from "@cede/types";

export const mockedOrder: Order = {
  id: "370555728513",
  pairSymbol: "BTC/USDT",
  side: "sell",
  status: OrderStatus.OPEN,
  type: OrderType.LIMIT,
  price: 50000,
  amount: 0.001,
  filled: 0,
  timestamp: 1631103999,
  fee: {
    amount: 0.001,
    tokenSymbol: "USDT",
  },
};
